import * as React from 'react'
import { mergeClasses, Text } from '@fluentui/react-components'
import { FileStatus, IOverviewItemDto } from '../../config/fileConfig'
import FormattedDateTime from '../../components/Date/FormattedDateTime'
import PersonAvatar from '../../components/PersonAvatar'
import { Link } from 'react-router-dom'
import { BaseOverviewLineItemProps, useOverviewStyles } from '../BaseOverview/BaseOverview'
import { FileFilterType, FileSortingType } from './FileOverview'

export function FileListItem(props: BaseOverviewLineItemProps<IOverviewItemDto, FileFilterType, FileSortingType>) {
    const overviewStyles = useOverviewStyles()

    return (
        <>
            <PersonAvatar
                className={props.viewportNarrow && overviewStyles.gridSpan2Rows}
                name={props.item.owner.fullName}
                color={'colorful'}
                size={24}
            />
            <Link
                to={`/file/${props.item.id}`}
                className={mergeClasses(
                    props.viewportNarrow && overviewStyles.gridSpan2Columns,
                    props.item.status === FileStatus.Open ? 'item-open' : 'item-closed',
                )}
            >
                {props.item.name}
            </Link>
            <Link to={`/file/${props.item.id}`} className={props.item.status === FileStatus.Open ? 'item-open' : 'item-closed'}>
                <Text size={200}>{props.item.reference}</Text>
            </Link>
            <div className={overviewStyles.alignEnd}>{props.item.lastAccess && <FormattedDateTime date={props.item.lastAccess} />}</div>
        </>
    )
}
